import { render, staticRenderFns } from "./UserPromotion.vue?vue&type=template&id=3a97bb96&"
import script from "./UserPromotion.vue?vue&type=script&lang=js&"
export * from "./UserPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports